import React from 'react'
import DesktopOnly from '../../styles/DesktopOnly'
import MobileOnly from '../../styles/MobileOnly'
import StandardVerticalSpace from '../../styles/StandardVerticalSpace'
import { DolaThemes } from '../../styles/types'
import Subheader, { SubheaderProps } from '../Subheader'
import { HeaderWrapper, LineWrapper, RightItem } from './styles'
import { H1, H2 } from '../../styles/Elements'

export interface HeaderProps {
  rightItem?: React.ReactChild
  title: React.ReactChild
  theme?: DolaThemes
  subtitle: React.ReactChild
  subheader?: SubheaderProps
}

const Header: React.FC<HeaderProps> = ({
  rightItem,
  theme = 'light',
  title,
  subtitle,
  subheader,
}) => {
  return (
    <HeaderWrapper dolaTheme={theme}>
      <header>
        <div className="content">
          <LineWrapper>
            <div>
              <H1>{title}</H1>
            </div>
            <MobileOnly>
              <RightItem>{rightItem}</RightItem>
            </MobileOnly>
          </LineWrapper>
          <LineWrapper>
            <div>
              <H2>{subtitle}</H2>
            </div>
            <DesktopOnly>
              <RightItem>{rightItem}</RightItem>
            </DesktopOnly>
          </LineWrapper>
        </div>
      </header>
      {!!subheader && (
        <>
          <StandardVerticalSpace />
          <Subheader {...subheader} theme={theme} />
        </>
      )}
    </HeaderWrapper>
  )
}

export default Header
